<template>
  <component :is="tag" v-bind="$attrs" :class="classes">
    <slot />
  </component>
</template>

<script>
export default {
  name: "BaseNav",
  inheritAttrs: false,
  props: {
    /** Specify the HTML tag instead of default “ul” */
    tag: { type: String, default: "ul" },

    /** Align the nav items: 'start' (or 'left'), 'center', 'end' (or 'right') */
    align: { type: String, default: null },

    /** Set this when the nav is placed inside a card header */
    cardHeader: { type: Boolean, default: false },

    /** Proportionately fill all horizontal space (but items keep natural widths) */
    fill: { type: Boolean, default: false },

    /** Equal-width nav items */
    justified: { type: Boolean, default: false },

    /** Render the nav items as pill-style buttons */
    pills: { type: Boolean, default: false },

    /** Make the nav smaller (adds .small) */
    small: { type: Boolean, default: false },

    /** Render the nav items as tab-style headers */
    tabs: { type: Boolean, default: false },

    /** Render the nav vertically (stacked) */
    vertical: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      const cls = ["nav"];

      // Variants
      if (this.tabs) cls.push("nav-tabs");
      if (this.pills) cls.push("nav-pills");
      if (this.cardHeader) cls.push("card-header-nav");
      // Fill & justified
      if (this.fill) cls.push("nav-fill");
      if (this.justified) cls.push("nav-justified");

      // Alignment (horizontal)
      if (this.align) {
        let a = this.align;
        if (a === "left") a = "start";
        if (a === "right") a = "end";
        cls.push(`justify-content-${a}`);
      }

      // Vertical stack
      if (this.vertical) cls.push("flex-column");

      // Small text
      if (this.small) cls.push("small");

      return cls;
    },
  },
};
</script>
